    <p-drawer
      [(visible)]="visible"
      (visibleChange)="visibleChange.emit($event)"
      position="right"
      [style]="{ width: '380px' }"
      header="Filters"
    >
      <div class="flex flex-col gap-6 py-2">

        <!-- Date Range -->
        <div class="flex flex-col gap-2">
          <label class="text-xs font-semibold uppercase tracking-wider text-dim">Date Range</label>
          <p-datepicker
            [(ngModel)]="localDateRange"
            selectionMode="range"
            [showIcon]="true"
            [showClear]="true"
            [readonlyInput]="true"
            dateFormat="yy-mm-dd"
            icon="pi pi-calendar"
            placeholder="YYYY-MM-DD - YYYY-MM-DD"
            styleClass="w-full"
            appendTo="body"
          />
        </div>

        <!-- Invoice Status -->
        <div class="flex flex-col gap-2">
          <label class="text-xs font-semibold uppercase tracking-wider text-dim">Status</label>
          <p-multiselect
            [(ngModel)]="localStatus"
            [options]="statusOptions"
            placeholder="All statuses"
            styleClass="w-full"
            appendTo="body"
          />
        </div>

        <!-- Invoice Type -->
        <div class="flex flex-col gap-2">
          <label class="text-xs font-semibold uppercase tracking-wider text-dim">Type</label>
          <p-selectbutton
            [(ngModel)]="localInvoiceType"
            [options]="typeOptions"
            styleClass="w-full"
          />
        </div>

      </div>

      <!-- Footer actions -->
      <ng-template #footer>
        <div class="flex flex-col gap-2 pt-2">
          <button
            type="button"
            (click)="applyFilters()"
            class="w-full py-2.5 rounded-lg bg-primary text-white dark:text-ink text-sm font-semibold hover:bg-primary/90 transition-colors"
          >Apply Filters</button>
          <button
            type="button"
            (click)="resetFilters()"
            class="w-full py-2 text-sm text-dim hover:text-ink transition-colors"
          >Reset All</button>
        </div>
      </ng-template>
    </p-drawer>
  
